import { TinyMCE } from 'tinymce';

// // import 'expose-loader?silver!tinymce/themes/silver';

import 'tinymce/themes/silver'
import 'tinymce/icons/default';

import './iv_tinymce_skin.css';
// importing content this way will affect the whole site (fonts ...)
// import 'tinymce/skins/content/default/content.min.css'

import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/table';
import 'tinymce/plugins/code';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/contextmenu';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/hr';
import 'tinymce/plugins/lists';
// import 'tinymce/plugins/advtable';

import '@dimakorotkov/tinymce-mathjax';

import '../../packs/langs/de.js'

const $el = document.querySelector('.js-wysiwyg');

function imageUploaderHandler (blobInfo, success, failure, progress) {
  var xhr, formData;

  xhr = new XMLHttpRequest();
  xhr.withCredentials = false;
  
  xhr.open('POST', $el.dataset.pathImageUpload);
  xhr.setRequestHeader("X-CSRF-Token", document.querySelector('meta[name="csrf-token"]').content);

  xhr.upload.onprogress = function (e) {
    progress(e.loaded / e.total * 100);
  };

  xhr.onload = function() {
    var json;

    if (xhr.status === 403) {
      failure('HTTP Error: ' + xhr.status, { remove: true });
      return;
    }

    if (xhr.status < 200 || xhr.status >= 300) {
      failure('HTTP Error: ' + xhr.status);
      return;
    }
    

    json = JSON.parse(xhr.responseText);

    if (!json || typeof json.url != 'string') {
      failure('Invalid JSON: ' + xhr.responseText);
      return;
    }

    success(json.url);
  };

  xhr.onerror = function () {
    failure('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
  };

  formData = new FormData();
  formData.append('file', blobInfo.blob(), blobInfo.filename());

  xhr.send(formData);
};

function initEditor() {
    tinymce.init({
      selector: '.js-wysiwyg',
      branding: false,
      skin: false,
      content_css: false,
      menubar: false,
      toolbar_sticky: true,
      keep_styles: false,
      language: $el.dataset.locale,
      
      mathjax: {
        lib: 'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-svg.js', //required path to mathjax
        //symbols: {start: '\\(', end: '\\)'}, //optional: mathjax symbols
        // className: 'math-tex', //optional: mathjax element class
        configUrl: $el.dataset.pathMathjaxConfig
      },
      content_css: $el.dataset.pathContentCss,
      images_upload_url: $el.dataset.pathImageUpload,
      images_upload_base_path: '',
      image_caption: true,
      link_class_list: [
        {title: 'None', value: ''},
        {title: 'Button', value: 'btn btn-primary'},
        {title: 'Button small', value: 'btn btn-primary btn-tiny'},
        {title: 'Button large', value: 'btn btn-primary btn-lg'}
      ],
      external_plugins: {
        'iv-columns': $el.dataset.pathPluginIvcol,
        'iv-well': $el.dataset.pathPluginIvwell,
        'iv-panel': $el.dataset.pathPluginIvpanel,
      },
      plugins: ['paste', 'link', 'lists', 'image', 'mathjax', 'table', 'code', 'hr', 'contextmenu','searchreplace', 'visualblocks', 'autoresize' ],
      table_responsive_width: true,
      toolbar: 'undo redo | styleselect | bold italic | numlist bullist | alignleft aligncenter alignright alignjustify | iversity link image mathjax | table contextmenu hr superscript subscript  | outdent indent | searchreplace preview code' ,
      images_upload_handler: imageUploaderHandler,
      toolbar_groups: {
        iversity: {
            text: 'iversity',
            icon: 'bookmark',
            tooltip: 'iversity elements',
            items: 'iv-columns iv-well iv-panel'
        }
      },
      style_formats: [
        {
            title: 'Image Left',
            selector: 'img',
            styles: {
                'float': 'left',
                'margin': '1rem'
            }
        },
        {
            title: 'Image Right',
            selector: 'img',
            styles: {
                'float': 'right',
                'margin': '1rem'
            }
        }
      ],
      style_formats_merge: true,
      style_formats_autohide: true,
      // visualblocks_default_state: true,
      // end_container_on_empty_block: true,
      non_empty_elements: "td,th,iframe,video,audio,object,script,pre,code,area,base,basefont,br,col,frame,hr,img,input,isindex,link,meta,param,embed,source,wbr,track, svg,defs,pattern,desc,metadata,g,mask,path,line,marker,rect,circle,ellipse,polygon,polyline,linearGradient,radialGradient,stop,image,view,text,textPath,title,tspan,glyph,symbol,switch,use",
      extended_valid_elements: "*[*]",
  });
}

if ( $el ) {
  initEditor();
}  